import type { LogoutModeActions } from './ErrorPage.types';

/**
 * Returns the button configuration for logout-mode error pages.
 *
 * - External users: "Get help" (primary) + "Log out" (secondary)
 * - Internal users: "Log out" (primary only, no "Get help")
 *
 * Internal (B2E) users have access to internal support channels,
 * so "Get help" is not shown. The primary action becomes "Log out".
 */
export function getLogoutModeActions(
  isInternalUser: boolean,
  navigateToHelp: () => void,
  logout: () => void
): LogoutModeActions {
  if (isInternalUser) {
    return {
      primaryLabel: 'Log out',
      primaryAction: logout,
      showPrimary: true,
      secondaryLabel: undefined,
      secondaryAction: undefined,
    };
  }

  return {
    primaryLabel: 'Get help',
    primaryAction: navigateToHelp,
    showPrimary: true,
    secondaryLabel: 'Log out',
    secondaryAction: logout,
  };
}
